import { z } from "zod";

export const WEBHOOK_SUBSCRIBABLE_EVENTS = ["lead.status_changed", "list.completed"] as const;
export const WEBHOOK_RESERVED_EVENTS = ["signal.created"] as const;
export type WebhookSubscriptionEvent = (typeof WEBHOOK_SUBSCRIBABLE_EVENTS)[number];
export type WebhookSubscriptionEventName =
	| WebhookSubscriptionEvent
	| (typeof WEBHOOK_RESERVED_EVENTS)[number];
export enum WebhookListScope {
	ALL = "ALL",
	SELECTED = "SELECTED",
}
export const webhookSubscriptionSchema = z.object({
	events: z
		.array(z.enum(WEBHOOK_SUBSCRIBABLE_EVENTS))
		.refine((v) => new Set(v).size === v.length, "Duplicate events"),
	listScope: z.enum(WebhookListScope),
	listIds: z
		.array(z.number().int().positive())
		.refine((v) => new Set(v).size === v.length, "Duplicate list ids"),
});
/** Response-only visibility count; never accepted as subscription configuration. */
export const webhookSubscriptionResponseSchema = webhookSubscriptionSchema.extend({
	privateListCount: z.number().int().nonnegative(),
});
export const webhookSubscriptionPatchSchema = webhookSubscriptionSchema.partial();
export type WebhookSubscription = z.infer<typeof webhookSubscriptionSchema>;
export const EMPTY_WEBHOOK_SUBSCRIPTION: WebhookSubscription = {
	events: [],
	listScope: WebhookListScope.ALL,
	listIds: [],
};
export type WebhookStatusChangeSource = "MANUAL" | "BLACKLIST" | "SCORING";
